import { Loader } from '@huggg/react-components';
import { Error } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './cmsContent.module.scss';

const ready = (content, title) => (
  <>
    <h1 className={styles.secondaryPageTitle}>{title}</h1>
    <div
      className={styles.cmsContent}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  </>
);

export const CMSContent = (props) => {
  const {
    content,
    error,
    fetchContent,
    fetchHuggg,
    huggg,
    match,
    onContentLoaded,
    title,
  } = props;
  const { shortcode } = match.params;

  if (!huggg.id) {
    fetchHuggg(shortcode);
  } else if (!content && !error) {
    fetchContent();
  }

  if (!content && !error) {
    return <Loader />;
  }

  if (content && onContentLoaded) {
    onContentLoaded(content, huggg);
  }

  return content ? ready(content, title) : <Error errorMessage={error} />;
};

CMSContent.propTypes = {
  fetchHuggg: PropTypes.func.isRequired,
  fetchContent: PropTypes.func.isRequired,
  onContentLoaded: PropTypes.func,
  match: PropTypes.object.isRequired,
  content: PropTypes.string,
  error: PropTypes.string,
  huggg: PropTypes.object,
  title: PropTypes.string,
};

export default withRouter(CMSContent);
